import {
  Flex,
  IconDownload,
  Spinner,
  Tag,
  Typography,
} from '@banhala/ui-kit';
import { localizeNumber } from 'shared/src/utils';

export type CouponState =
  | 'anonymous'
  | 'loading'
  | 'none'
  | 'issued'
  | 'downloadable';

export const CouponStateTag = ({
  state,
  couponCount,
  discount,
  onPressDownload,
}: {
  state: CouponState;
  couponCount: number;
  discount: number;
  onPressDownload: () => void;
}) => {
  if (state === 'loading') {
    return (
      <Flex.Center width={24}>
        <Spinner size={14} />
      </Flex.Center>
    );
  }

  if (state === 'none') {
    return (
      <Typography color={'content_tertiary'} type={'body2'}>
        사용 가능한 쿠폰 없음
      </Typography>
    );
  }

  if (state === 'issued') {
    return (
      <Flex.Row alignItems={'center'} gap={8}>
        {couponCount > 1 ? (
          <Flex.Row alignItems={'center'} gap={4}>
            <Tag color="slate" size="small" type="secondary">
              중복할인
            </Tag>
            <Tag color="pink" size="small" type="secondary">
              최대할인
            </Tag>
          </Flex.Row>
        ) : (
          <Tag color="pink" size="small" type="secondary">
            최대 할인 적용
          </Tag>
        )}
        <Typography type={'body2'} color={'content_primary'}>
          -{localizeNumber(discount)}원
        </Typography>
      </Flex.Row>
    );
  }

  return (
    <Flex onPress={onPressDownload}>
      <Tag color="blue" size="small" type="secondary" icon={IconDownload}>
        최대 할인 쿠폰 받기
      </Tag>
    </Flex>
  );
};
